import { makeEroadStyles } from "../../../styles";

type StyleProps = {
  relative?: boolean;
  withMargin: boolean;
};

const useStyles = makeEroadStyles(
  (theme) => ({
    root: ({ relative, withMargin }: StyleProps) => ({
      ...(relative && { position: "relative" }),
      ...(withMargin && { margin: theme.spacing(4) }),
      background: theme.colors.surfaceLevel2,
      flex: 1,
      minHeight: 0,
      // ^ fixes the issue on Safari (v14.1.1, macOS 11.4 ) where browser can't decide on the height of the container and renders blank page.
      // browser resize event needs to be triggered to bring back the content.
    }),
  }),
  { name: "PageContent" }
);

export { useStyles };
